import React from 'react';
export const DiagonalUpwardArrowIcon = () => {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.511 6v2.55h4.136l-7.273 7.272a1.276 1.276 0 1 0 1.804 1.804l7.271-7.271v4.134H18V6H9.511Z",
    clipRule: "evenodd"
  }));
};